import React from 'react';
import SideBar from './SideBar';
import HeaderSection from './HeaderSection';

export default function Notifications() {

    return (
        <>
            <div className="container-scroller">
                <SideBar />
                <div className="main-panel">
                    <div className="content-wrapper">
                        <HeaderSection />


                        <div className="my-profile-saction">
                            <div className="my-profile-saction-inner">
                                <h2>Notifications</h2>
                                <ul className='notifaction-list'>
                                    <li>
                                        <div className="list-li-left">
                                            <span>Views Limit</span>
                                            <p>Emails notifying about reaching the views limit and widget’s deactivation.</p>
                                        </div>
                                        <div className="list-li-right">
                                            <div className="form-group">
                                                <input type="checkbox" id="toggle_2" className="chkbx-toggle" value="1" />
                                                <label for="toggle_2"></label>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="list-li-left">
                                            <span>Recommendations and Tips</span>
                                            <p>Emails providing tailored recommendations and practical tips.</p>
                                        </div>
                                        <div className="list-li-right">
                                        <div className="form-group">
                                                <input type="checkbox" id="toggle_3" className="chkbx-toggle" value="1" />
                                                <label for="toggle_3"></label>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="list-li-left">
                                            <span>Monthly Digests</span>
                                            <p>Monthly digests of our latest improvements and Community updates.</p>
                                        </div>
                                        <div className="list-li-right">
                                        <div className="form-group">
                                                <input type="checkbox" id="toggle_5" className="chkbx-toggle" value="1" />
                                                <label for="toggle_5"></label>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="list-li-left">
                                            <span>Affiliate Program</span>
                                            <p>All information about our Affiliate Program and updates for our affiliates.</p>
                                        </div>
                                        <div className="list-li-right">
                                        <div className="form-group">
                                                <input type="checkbox" id="toggle_6" className="chkbx-toggle" value="1" />
                                                <label for="toggle_6"></label>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="list-li-left">
                                            <span>Deals</span>
                                            <p>Emails highlighting exclusive Black Friday deals and other major sales.</p>
                                        </div>
                                        <div className="list-li-right">
                                        <div className="form-group">
                                                <input type="checkbox" id="toggle_7" className="chkbx-toggle" value="1" />
                                                <label for="toggle_7"></label>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </>
    );
}
